import Component from '@glimmer/component';

import ReportsViewerPagelessComponent from 'webapp/components/reports/viewer-pageless';
import ReportsViewerSlidesComponent from 'webapp/components/reports/viewer-slides';

import type { ReportSlide } from 'webapp/models-custom';
import type Report from 'webapp/models-custom/report';

interface Args {
	model?: Report | null; // can be missing because of public report template - getting report data via token endpoint
	isLoaderShown?: boolean;
	selectedSlide?: ReportSlide | null;
	onBoardPreviewHashChange?: (boardId: string, previewHash?: string) => void;
	onSlideChange?: (index: number) => void;
}

export default class ReportsViewerComponent extends Component<Args> {
	get isPageless() {
		return this.args.model?.isPageless;
	}
	<template>
		{{#if this.isPageless}}
			<ReportsViewerPagelessComponent
				@model={{@model}}
				@isLoaderShown={{@isLoaderShown}}
				@onBoardPreviewHashChange={{@onBoardPreviewHashChange}}
			/>
		{{else}}
			<ReportsViewerSlidesComponent
				@model={{@model}}
				@isLoaderShown={{@isLoaderShown}}
				@onBoardPreviewHashChange={{@onBoardPreviewHashChange}}
				@onSlideChange={{@onSlideChange}}
				@selectedSlide={{@selectedSlide}}
			/>
		{{/if}}
	</template>
}
